import { render, staticRenderFns } from "./MinusStatisManage.vue?vue&type=template&id=ac82915c&"
import script from "./MinusStatisManage.vue?vue&type=script&lang=js&"
export * from "./MinusStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports